import axios from 'axios';
import { getApiUrl } from '../../../config/api';

export class AddUsuarioController {
  constructor() {
    this.usuario = {
      UsuarioId: '',
      Password: '',
      Nombre: '',
      Email: '',
      EsActivo: false,
      fecha_confirmacion: null,
      zEmpleado: '',
      zSerie: '',
      usuario_id_consulta: ''
    };
    this.saving = false;
    this.error = null;
  }

  /**
   * Inicializa el estado del controlador
   */
  init() {
    this.resetForm();
  }

  /**
   * Resetea el formulario a su estado inicial
   */
  resetForm() {
    this.usuario = {
      UsuarioId: '',
      Password: '',
      Nombre: '',
      Email: '',
      EsActivo: false,
      fecha_confirmacion: null,
      zEmpleado: '',
      zSerie: '',
      usuario_id_consulta: ''
    };
    this.saving = false;
    this.error = null;
  }

  /**
   * Valida los datos del usuario antes de enviar
   * @returns {boolean} true si los datos son válidos
   */
  validateUsuario() {
    if (!this.usuario.UsuarioId || this.usuario.UsuarioId.trim() === '') {
      this.error = 'El ID de usuario es requerido';
      return false;
    }

    if (!this.usuario.Password || this.usuario.Password.trim() === '') {
      this.error = 'La contraseña es requerida';
      return false;
    }

    if (this.usuario.UsuarioId.length > 20) {
      this.error = 'El ID de usuario no puede exceder 20 caracteres';
      return false;
    }

    if (this.usuario.Password.length > 40) {
      this.error = 'La contraseña no puede exceder 40 caracteres';
      return false;
    }

    if (this.usuario.Email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.usuario.Email)) {
      this.error = 'El formato del email no es válido';
      return false;
    }

    this.error = null;
    return true;
  }

  /**
   * Prepara los datos del usuario antes del envío
   */
  prepareUsuarioData() {
    // Si el usuario está activo, establecer la fecha de confirmación
    if (this.usuario.EsActivo) {
      this.usuario.fecha_confirmacion = new Date().toISOString();
    } else {
      this.usuario.fecha_confirmacion = null;
    }
  }

  /**
   * Crea un nuevo usuario
   * @returns {Promise} Promise que resuelve cuando el usuario es creado
   */
  async createUsuario() {
    if (!this.validateUsuario()) {
      return Promise.reject(new Error(this.error));
    }

    this.saving = true;
    this.error = null;

    try {
      this.prepareUsuarioData();
      
      const response = await axios.post(getApiUrl('/api/Usuario/insertar'), this.usuario);
      
      this.saving = false;
      return response.data;
    } catch (error) {
      console.error('Error al guardar usuario:', error);
      this.error = 'No se pudo guardar el usuario. Por favor, verifique los datos e intente nuevamente.';
      this.saving = false;
      throw error;
    }
  }

  /**
   * Actualiza un campo específico del usuario
   * @param {string} field - Nombre del campo
   * @param {any} value - Valor del campo
   */
  updateField(field, value) {
    if (Object.prototype.hasOwnProperty.call(this.usuario, field)) {
      this.usuario[field] = value;
      // Limpiar error cuando el usuario modifica los datos
      if (this.error) {
        this.error = null;
      }
    }
  }

  /**
   * Obtiene el estado actual del usuario
   * @returns {Object} Copia del objeto usuario
   */
  getUsuario() {
    return { ...this.usuario };
  }

  /**
   * Obtiene el estado de guardado
   * @returns {boolean} true si está guardando
   */
  isSaving() {
    return this.saving;
  }

  /**
   * Obtiene el error actual
   * @returns {string|null} Mensaje de error o null
   */
  getError() {
    return this.error;
  }
}

// Exportar una instancia por defecto para uso directo
export default new AddUsuarioController();